import { render } from "./Modal_Declaration.vue?vue&type=template&id=45282782&scoped=true"
import script from "./Modal_Declaration.vue?vue&type=script&lang=js"
export * from "./Modal_Declaration.vue?vue&type=script&lang=js"

import "./Modal_Declaration.vue?vue&type=style&index=0&id=45282782&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45282782"]])

export default __exports__